import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CartSharedModule } from '@spartacus/cart/base/components'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { CustomCartSharedModule } from '../../cart/cart-shared/custom-cart-shared.module'
import { CustomCheckoutOrderSummaryComponent } from './custom-checkout-order-summary.component'

@NgModule({
  declarations: [CustomCheckoutOrderSummaryComponent],
  imports: [CommonModule, CartSharedModule, CustomCartSharedModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutOrderSummary: {
          component: CustomCheckoutOrderSummaryComponent
        }
      }
    })
  ],
  exports: [CustomCheckoutOrderSummaryComponent]
})
export class CustomCheckoutOrderSummaryModule {}
